import { StatisticsStorage } from "../storage/statistics_storage.js";
import { AuthSessionStore } from "../api/auth_session.js";
import { submitConveyorRecord } from "../api/requests/conveyor.requests.js";
import { LocalizationManager } from "../localization/localization_manager.js";

export class ConveyorRecord
{
  public static get(): number
  {
    return StatisticsStorage.load().conveyor_record_seconds;
  }

  public static submit( seconds: number ): void
  {
    const run = Math.max( 0, Math.floor( seconds ) );

    if ( run <= ConveyorRecord.get() )
      return;

    StatisticsStorage.update( { conveyor_record_seconds: run } );

    if ( !AuthSessionStore.isLoggedIn() )
      return;

    submitConveyorRecord( run )
      .then( dto => ConveyorRecord.adopt( dto.conveyor_record_seconds ) )
      .catch( e => console.warn( "[ConveyorRecord] submit failed", e ) );
  }

  public static format( seconds: number ): string
  {
    const minutes = Math.floor( seconds / 60 );
    const rest = seconds % 60;
    const m = LocalizationManager.t( "TIME.SHORT_MINUTES" );
    const s = LocalizationManager.t( "TIME.SHORT_SECONDS" );

    return minutes > 0 ? `${minutes}${m} ${rest}${s}` : `${rest}${s}`;
  }

  public static adopt( server_seconds: number ): void
  {
    if ( server_seconds > ConveyorRecord.get() )
      StatisticsStorage.update( { conveyor_record_seconds: server_seconds } );
  }
}
